import { Link } from "react-router-dom";
import { Logo } from "./Decor";
import { COMPANY } from "../lib/data";

export default function Footer() {
  return (
    <footer className="mv-footer" data-testid="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="nav-logo" style={{ textDecoration: "none" }}>
              <div className="logo-box" style={{ background: "white", boxShadow: "none", padding: "5px 12px 5px 5px", gap: 8, borderRadius: 10 }}>
                <Logo size={30} />
                <div className="nav-logo-wordmark">
                  <span className="nav-logo-name">{COMPANY.name}</span>
                  <span className="nav-logo-tagline">Supply Chain Solutions</span>
                </div>
              </div>
            </Link>
            <p>Supply chain systems consulting for warehouses, distributors, and 3PLs. WMS optimization, warehouse process improvement, and fractional supply chain support.</p>
            <Link to="/contact" className="btn-primary" style={{ fontSize: "0.82rem", padding: "9px 18px" }}>Schedule a Call →</Link>
          </div>
          <div className="footer-col">
            <h5>Services</h5>
            <ul>
              <li><Link to="/services">WMS Health Assessment</Link></li>
              <li><Link to="/services">Warehouse Optimization</Link></li>
              <li><Link to="/services">WMS Implementation</Link></li>
              <li><Link to="/services">Fractional WMS Analyst</Link></li>
              <li><Link to="/services">Fractional SC Systems Analyst</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Industries</h5>
            <ul>
              <li><Link to="/industries">3PL</Link></li>
              <li><Link to="/industries">Distribution</Link></li>
              <li><Link to="/industries">Ecommerce Fulfillment</Link></li>
              <li><Link to="/industries">Manufacturing</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Company</h5>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/process">How We Work</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {COMPANY.full}. All rights reserved.</p>
          <p><Link to="/contact">Privacy Policy</Link> · <Link to="/contact">Terms of Service</Link></p>
        </div>
      </div>
    </footer>
  );
}
